import { render, staticRenderFns } from "./textFacebook.vue?vue&type=template&id=155cb990&"
import script from "./textFacebook.vue?vue&type=script&lang=js&"
export * from "./textFacebook.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports